import { Component, OnInit } from '@angular/core';
import { ForgotPasswordService } from '../../services/ForgotPassword.service';
import { Router } from '@angular/router';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';


@Component({
  selector: 'app-forgot-username',
  templateUrl: './forgot-username.component.html',
  styleUrls: ['./forgot-username.component.css']
})

export class ForgotUsernameComponent implements OnInit {
  isSubmitError: boolean = false;
  isSubmitSuccess: boolean = false;
  errorMessage: string = '';
  loader: boolean = false;
  submit: boolean = false;
  isPanelSelected: boolean = true;
  panel: string = null;
  userNameEmail: string;
  panelSelected: string;
  userList: any[] = [];
  linkMessage: string = "";
  selectedUser: string = null;
  listOfUser: boolean = false;
  constructor(private forgotService: ForgotPasswordService, private Router: Router) {}

  ngOnInit() {
    this.listOfUser = false;
  }

  selectPanel(value) {
    this.isPanelSelected = value != "null" ? true : false;

  }

  onSubmit(ForgotPasswordForm) {
    this.loader = true;
    
    if (ForgotPasswordForm.value.panel == "null" || ForgotPasswordForm.value.Panel == undefined) {
      this.isPanelSelected = false;
      this.loader = false;
    } else {
      this.forgotService.getForgotUserNameList(ForgotPasswordForm.value.email, ForgotPasswordForm.value.Panel).subscribe(
      (data: any) => {
        if (data.Id == "1") {
          this.userList = [];
          this.isSubmitError = false;
          this.panelSelected = "";
          this.panelSelected = ForgotPasswordForm.value.Panel;
          this.linkMessage = "";
          this.linkMessage = this.panelSelected == "2" ? "HA " : this.panelSelected == "4" ? "PA" : "";
          this.userList = data.UserList;
          this.listOfUser = true;
          ForgotPasswordForm.reset();
        }
        else{
          alert(" Email Not found");
        }
      },
      (error) => {
        this.isSubmitError = true;
        this.listOfUser = false;
        this.errorMessage = error.error[0];

      }).add(() => {
        this.loader = false;
      });
    }
  }

  onSubmitUser(userForm) {
    this.loader = true;
    if (this.panelSelected == "null" || this.panelSelected == undefined) {
      this.loader = false;
    } else {
      var userValue: string = "";
      userValue = userForm.value.userval;
      this.forgotService.sendForgotUsername(userValue, this.panelSelected).subscribe(
      (data) => {
        this.loader = false;
        userForm.reset();
        this.isSubmitSuccess = true;
        this.isSubmitError = false;
        this.errorMessage = data["StatusMessage"];
        AlertMessages.Show('Success', 'Username sent!',AlertType.Success);
        if (status) this.alertClose();

      },
      (error) => {
          this.isSubmitError = true;
          this.isSubmitSuccess = false;
        this.errorMessage = error.error[0];
        AlertMessages.Show('Failed', error.error[0],AlertType.Error);

      });
    }
  }

  alertClose() {
    setTimeout(() => {
      this.isSubmitSuccess = false;
      this.Router.navigate(['login']);
    }, 3000);
  }

}
